<template>
  <div class="Home-container">

    <track-info-panel :info="trackInfo"></track-info-panel>

    <div class="Loading" v-if="!instance || !instance.timeline || !instance.timeline.playlists">
      <font-awesome-icon :icon="['far', 'circle-notch']" spin></font-awesome-icon> Loading Timeline
    </div>

    <div id="Timeline" v-if="instance && instance.timeline && instance.timeline.playlists">

      <div class="segment" v-for="(playlist, playlistIndex) in instance.timeline.playlists">

        <div class="segment-row segment-show">

          <div class="segment-time">
            <div class="segment-time-inner">
               <span v-text="$moment(playlist.start).format(timeFormat.timeOnly)"></span>
            </div>
          </div>

          <div class="segment-content">
            <div class="show">
              <span v-if="isPlaylistCurrent(playlist)" class="label live">Live</span>
              <img class="show-image" :src="getShowImageURL(playlist, playlistIndex)" />
              <h3>Demo Show <span v-text="playlistIndex + 1"></span></h3>
              <div class="broadcast-date" v-text="$moment().format('MMMM D, YYYY')"></div>
            </div>
          </div>

        </div>

        <div 
          class="segment-row segment-track"
          v-for="(track, trackIndex) in playlist.tracks"
          v-if="track && track.item && isTrackVisible(track, trackIndex)"
          v-bind:key="track.$index"
        >

          <div class="segment-time">
            
            <div class="segment-time-inner">

              <div v-if="track.timelineScheduledCommand">Cart</div>
              <div v-if="track.timelineScheduledCommand" v-text="$moment(track.timelineScheduledCommandDate).format(timeFormat.timeWithSeconds)"></div>

            </div>

          </div>

          <div class="segment-content">

            <div class="track" 
              :class="{
                'status-current': isTrackCurrent(track),
                'status-playing': isTrackCurrent(track) && instance.status.playing,
                'status-stopped': isTrackCurrent(track) && !instance.status.playing,
                'status-skipped': track.timelineSkip,
                'status-played': isTrackInPast(track) || (track.action && track.action.started_at && track.action.completed_at),
                'type-command': track.command,
                'track-move-active': UI.isMovingTrack,
                'track-moving-this': editing.track && track.id == editing.track.id,
                'track-item-missing': !track.item,
                'is-track-faded': isTrackFaded(track, trackIndex), 
                'is-track-extra-faded': isTrackExtraFaded(track, trackIndex),
                'is-track-in-past': isTrackInPast(track),
            }">

              <td 
                class="track-start" 
                :class="{ 'action-done': track.action && track.action.completed_at }" 
                v-text="track.action ? $moment(track.action.started_at).format(timeFormat.timeWithSeconds) : track.timelineStart? $moment(track.timelineStart).format(timeFormat.timeWithSeconds) : ''">    
              </td>
                
              <td class="track-info">
                <!-- <b v-if="!track.item">No item found.</b> -->
                <b class="track-artist" v-if="track.item" v-text="track.item.artist ? $a2C(track.item.artist) : track.command ? track.command : 'Unknown'"></b>
                <span class="track-title" v-if="track.item" v-text="track.item.title ? $a2C(track.item.title) : 'Untitled'"></span>
              </td>

            </div><!--end track-->
          </div><!--end segment-content-->
        </div><!--end segment-row segment-track-->

        
        <div class="segment-row segment-expand">
          <div class="segment-time">
            <div class="segment-time-inner">
            </div>
          </div>
          <div class="segment-content">
            <button 
              @click="expandPlaylist(playlist)" 
              v-if="!isPlaylistExpanded(playlist)">
              Expand
            </button>
            <button 
              @click="collapsePlaylist(playlist)" 
              v-if="isPlaylistExpanded(playlist) && !isPlaylistCurrent(playlist)">
              Collapse
            </button>
          </div>
        </div>
  

      </div><!--end segment-->

    </div>

  </div>
</template>

<script>

import TrackInfoPanel from '@/components/TrackInfoPanel';

// Icons
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'page-timeline',
  props: ['instance', 'config'],
  components: {
    FontAwesomeIcon,
    TrackInfoPanel,
  },
  data() {
    return {

      // TODO: Replace this with a timezone from the Device API?
      // momentParseFormat: 'YYYY-MM-DD HH:mm:ss -07:00',

      timeFormat: {
        withDate: 'YYYY-MM-DD HH:mm:ss',
        timeOnly: 'h:mma',
        timeWithSeconds: 'h:mm:ssa',
      },

      UI: {
        // isTrackEditMenuVisible: false
        isMovingTrack: false,
        isInsertingTrack: false,
        isLoadingMoveTrack: false,
        expandedPlaylists: {},
        trackVisibleDefaultNum: 3,
      },

      editing: {
        track: null
      },

      trackInfo: null

    }
  },
  methods: {

    clone(obj){
      return JSON.parse(JSON.stringify(obj))
    },

    getPathFromMeta(metaStringJSON) {

      if(!metaStringJSON) {
        return null;
      }
      
      const parsedJSON = JSON.parse(metaStringJSON)

      return parsedJSON.path || null

    },

    getShowImageURL(playlist, playlistIndex){

      return `/demo-show-images/compressed/dog-${playlistIndex}.png`

    },

    expandPlaylist(playlist){
      this.UI.expandedPlaylists[playlist.id] = true
      this.$forceUpdate();
    },

    collapsePlaylist(playlist){
      this.UI.expandedPlaylists[playlist.id] = null
      this.$forceUpdate();
    },

    isPlaylistExpanded(playlist){
      if(
        this.UI.expandedPlaylists[playlist.id] 
        || this.isPlaylistCurrent(playlist) 
      ){
        return true
      }else{
        return false
      }
    },

    isPlaylistCurrent(playlist){
      if(
        playlist.id 
        && (
            playlist.id == this.$v(
              this.instance, 'status.current.track.playlist_id'
            )
          )
      ){
        return true
      }else{
        return false
      }
    },

    isTrackCurrent(track){
      return track && track.id
        && parseInt(track.id) === parseInt(
          this.$v(this.instance, 'status.current.track.id')
        )
    },

    isTrackVisible(track, trackIndex){

      if(
        track.playlist_id 
        && 
          (
            track.playlist_id == this.$v(
              this.instance, 'status.current.track.playlist_id'
            )
            || this.UI.expandedPlaylists[track.playlist_id]
            || trackIndex <= this.UI.trackVisibleDefaultNum - 1
          )
        ){
        return true
      }else{
        return false
      }

    },

    isTrackFaded(track, trackIndex){

      if(
        track.playlist_id 
        && trackIndex == this.UI.trackVisibleDefaultNum - 2
        && !this.isPlaylistExpanded({id:track.playlist_id})
        && !this.isPlaylistCurrent({id:track.playlist_id})
      ){
        return true
      }else{
        return false
      }

    },

    isTrackExtraFaded(track, trackIndex){

      if(
        track.playlist_id 
        && trackIndex == this.UI.trackVisibleDefaultNum - 1
        && !this.isPlaylistExpanded({id:track.playlist_id})
        && !this.isPlaylistCurrent({id:track.playlist_id})
      ){
        return true
      }else{
        return false
      }

    },

    isTrackInPast(track){
      if(this.$moment(track.timelineStart).isBefore(this.$moment())){
        return true
      }else{
        return false
      }
    },

    closeMoveTrack(track) {
      this.editing.track = track;
      this.UI.isMovingTrack = true;
    },

    openMoveTrack(track) {
      this.editing.track = track;
      this.UI.isMovingTrack = true;
    },

    closeMoveTrack() {
      this.editing.track = null;
      this.UI.isMovingTrack = false;
      this.UI.isLoadingMoveTrack = false;
    },
    
    toggleInsertTrack(track) {
      this.editing.track = track;
      this.UI.isInsertingTrack = this.UI.isInsertingTrack ? false : true;
    },

    deleteTrack(trackId){
      const parentThis = this;
      $axios
        .delete(`${this.config.address}/tracks/${trackId}`)
        .then((response) => {
          parentThis.$emit('refresh');
        })
        .catch((error) => {
          alert(error)
        });
    },

    moveTrack(trackId, fromPlaylistId, toPosition, toPlaylistId){
      const parentThis = this
      this.UI.isLoadingMoveTrack = true
      $axios
        .patch(`${this.config.address}/tracks/${trackId}`, { 
          toPosition: toPosition,
          toPlaylistId: toPlaylistId
        })
        .then((response) => {
          parentThis.$emit('refresh')
          parentThis.closeMoveTrack()
        })
        .catch((error) => {
          parentThis.closeMoveTrack()
        });
    },

    formatTime(seconds, includeMS) {
      // console.log(seconds)

      if (!seconds || typeof seconds === 'undefined') {
        return '';
      }

      // TODO: Include option for milliseconds.

      const date = new Date(null);
      date.setSeconds(seconds);
      const time = date.toISOString().substr(11, 8);
      let timeTrimmed = time;
      let trimLimit = 0;

      // Remove leading zeroes
      while ((timeTrimmed.substr(0, 1) === '0' || timeTrimmed.substr(0, 1) === ':') && trimLimit <= 3) {
        timeTrimmed = timeTrimmed.slice(1);
        trimLimit += 1;
      }

      return timeTrimmed;
    },

    scanFilesInPlaylist(playlist) {
      const parentThis = this;
      const callback = (err, response) => {
        alert('Started scanning files in playlist.');
      };
      $axios
        .post(`${this.config.address}/scan/library/playlist/${playlist.id}`, {})
        .then((response) => {
          parentThis.$emit('refresh');
          callback(null, response.data);
        })
        .catch((error) => {
          callback(error.data, null);
        });
    },

    deleteActionsFromPlaylist(playlist) {
      const parentThis = this;
      const callback = (err, response) => {
        alert(`Started deleting actions from tracks in this playlist.`);
      };
      $axios
        .delete(`${this.config.address}/actions/playlist/${playlist.id}`, {})
        .then((response) => {
          parentThis.$emit('refresh');
          callback(null, response.data);
        })
        .catch((error) => {
          callback(error.data, null);
        });
    },
  },
  mounted() {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

      
</style>
